import { ReactSelectStyles } from '../../types'
import customTheme from '../../../../../tailwind.config.js'

export function styles<T>(
  touched?: boolean,
  error?: string | boolean
): ReactSelectStyles<T> {
  return {
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      fontSize: '0.875rem',
      background: isSelected ? '#828282' : isFocused ? '#dedede' : undefined,
      color: isSelected ? '#FFF' : '#000',
      ':hover': {
        ...provided[':hover'],
        background: '#dedede',
        cursor: 'pointer'
      }
    }),
    control: (provided, { isFocused }) => ({
      ...provided,
      fontSize: '0.875rem',
      color: customTheme.theme.extend.colors.red,
      boxShadow: isFocused
        ? `0 0 0 0.15rem ${
            touched && error ? 'rgb(220 53 69 / 25%)' : '#c9c9c9'
          }`
        : undefined,
      borderColor:
        touched && error
          ? customTheme.theme.extend.colors.red
          : customTheme.theme.colors['v2-sonic-silver'],
      borderRadius: 9999,
      fontFamily: customTheme.theme.fontFamily.workSans.toString(),

      ':hover': {
        borderColor:
          touched && error
            ? customTheme.theme.extend.colors.red
            : customTheme.theme.colors['v2-sonic-silver']
      }
    }),
    dropdownIndicator: provided => ({
      ...provided,
      padding: '4px'
    }),
    valueContainer: provided => ({
      ...provided,
      paddingLeft: '16px',
      paddingTop: '6px',
      paddingBottom: '6px'
    }),
    singleValue: provided => ({
      ...provided,
      fontWeight: 'lighter',
      color: customTheme.theme.colors.black
    }),
    placeholder: provided => ({
      ...provided,
      color: customTheme.theme.colors['v2-sonic-silver'],
      fontWeight: 'lighter'
    })
  }
}
